import { ShippingProfilesApiClient } from '@fourthwall/services/dist/ShippingProfilesApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useSetShippingProfilesStateMutation = createMutationHook(
  ShippingProfilesApiClient.setShippingProfilesState,
  {
    mutationKey: ['setShippingProfilesState'],
  },
)
